module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_vm._v("\nsadasdasd\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95758076"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ConfirmReservation.vue
// module id = 748
// module chunks = 1